import { getWindow } from '../../../services/windowService';
import { makeObservable } from '../../../utils/makeObservable';
import { isGTMScriptLoaded } from '../useGoogleTagManager/isGTMScriptLoaded';
import { isGaScriptLoaded } from './isGaScriptLoaded';

const wnd = getWindow();

let loaded = false;
let delayedQueue: GtagArgs[] = [];

isGaScriptLoaded.subscribe((val) => (loaded = val));
isGTMScriptLoaded.subscribe((val) => (loaded = val));

export const gtagQueue = makeObservable<GtagArgs[]>([]);
gtagQueue.subscribe((queue) => {
  const { gtag } = wnd;
  if (!loaded) {
    delayedQueue.push(...queue);
    console.warn('Google Analytics script is not loaded');
    return;
  }
  while (delayedQueue.length) {
    const item = delayedQueue.shift();
    // console.log('delayedQueue', item);
    gtag(...item);
  }
  for (let item of queue) {
    // console.log('queue', item);
    gtag(...item);
  }
});

export type GtagArgs =
  | ['js', Date]
  | ['config', string, Record<string, any>]
  | ['set', string, string | Record<string, any>]
  | ['event', 'page_view']
  | ['event', 'page_view', Record<string, any>]
  | ['event', 'request_form', Record<string, any>]
  | ['event', 'create_configuration', Record<string, any>]
  | ['event', 'login', Record<string, any>]
  | ['event', 'login']
  | ['event', 'logout']
  | ['event', 'click', Record<string, any>];
export type GTag = (...args: GtagArgs) => void;

declare global {
  interface Window {
    gtag?: GTag;
    dataLayer: any[];
  }
}
